<template>

    <section class="w-100 h-100">

        <!-- Loading -->
        <loading/>

        <header class="d-flex flex-column mb-2">

            <h1 class="order-1">Social Media</h1>
            <p class="order-2">For get access of the clientId Account and token need to request in  
                <a href="https://business.facebook.com/" target="_blank" rel="noopener noreferrer" aria-describedby="Facebook Developer Plataform">https://business.facebook.com/</a>
            </p>

        </header>

        <form @submit.prevent="sendData(formaction)" action="" class="formfeedsettings"  method="post" aria-describedby="Feed Settings" enctype="application/x-www-form-urlencoded" autocomplete="on">

            <fieldset class="feedsettings" data-feedtype="instagram">

                <legend class="my-3">Instagram Settings</legend>

                <div class="mb-3">
                    <label for="instaclientid" class="form-label">Client Account Id</label>
                    <input @focusin="checkValueByFocus($event)" @focusout="checkValueByFocus($event)" type="text" v-model="instagram_clientid" class="form-control" id="instaclientid" aria-describedby="Instagram Client Id">
                </div>
    
                <div class="mb-3">
                    <label for="instatoken" class="form-label">Token</label>
                    <input @focusin="checkValueByFocus($event)" @focusout="checkValueByFocus($event)" type="text" v-model="instagram_token" class="form-control" id="instatoken" aria-describedby="Instagram Token">
                </div>

            </fieldset>
         
            <button type="submit" class="btn btn-primary float-end btnsubmit" :disabled="disabled">Submit</button>

        </form>

        <!-- Response Messages -->
        <div class="order-3 responsebasemessage" ref="responsebasemessage">

            <list-message/>

        </div>

    </section>   

</template>
<script>

import fetchData from './../../fetchData.js';
import ListMessage from './../elements/ListMessageElement.vue';
import Loading from './../elements/LoadingElement.vue';

//Set Use Strict
"use strict";

export default{
    name: 'FeedComponent',
    props:{

        csrftolken:{
            type: String,
            require: true
        },
        feedstore:{
            type: String,
            require: true
        },
        feedsdata:{
            type: String,
            require: true
        },
        feedupdate:{
            type: String,
            require: true
        }

    },
    data: () => {

        return  {

            instagram_clientid: '',
            instagram_token: '',
            disabled: true,
            formaction:'',
            alldata: {},
            activeclass: 'd-flex',

        }

    },
    created(){

        //Check Feeds Data
        this.alldata = JSON.parse(this.feedsdata);

        //Set Formaction Routine
        this.formaction = this.alldata.length === 0 ? 'insert' : 'update';

    },
    mounted(){

        //Set Values
        if(this.formaction === 'update'){

            //Related Values
            this.instagram_clientid = this.alldata[0].data.feedclientid;
            this.instagram_token = atob(atob(this.alldata[0].data.feedtoken));

            //Set Data Propertie
            document.querySelector('.feedsettings').setAttribute('data-feedid', this.alldata[0].id);

        }

    },
    methods:{

        removeResponseMessages(time = 5000){

            setTimeout(function(){

                //Remove active class
                document.querySelector('.responsebasemessage').classList.remove('d-flex');
                document.querySelector('.responsebasemessage').classList.remove('successmessage');
                document.querySelector('.responsebasemessage').classList.remove('errormessage');

                //Remove children elements
                let ul = document.querySelector('.responsebasemessage').children;

                [...ul[0].children].forEach((valli) => {

                    //Remove Elements
                    valli.remove();

                });

            }, time);

        },
        dataStructureResponse(responseObject){

            //Get Key and Value
            let entries = Object.entries(responseObject);

            //Loop response conditional
            for(const [key, value] of entries){

                switch(key)
                {

                    case 'attListData':

                        //Set Data
                        this.alldata = JSON.parse(value[0].data);

                        //Set Feed Id
                        let feedId = JSON.parse(value[0].id);

                        //Clean Variable
                        this.instagram_clientid = this.alldata.feedclientid;
                        this.instagram_token = atob(atob(this.alldata.feedtoken));

                        //Set Data Propertie
                        document.querySelector('.feedsettings').setAttribute('data-feedid', feedId);

                        //Set Formaction
                        this.formaction = 'update';

                        //Enabled Submit
                        document.querySelector('.btnsubmit').removeAttribute('disabled');

                    break;

                    case 'successMessage':
                    case 'errorMessage':
                        
                        //Add active Class
                        this.$refs.responsebasemessage.classList.add(this.activeclass);
                        this.$refs.responsebasemessage.classList.add(key.toLowerCase());

                        //Set Messages List
                        value.forEach((valmessage) => {

                            //Element for append
                            let li = `<li class="list-group item my-1">${valmessage}</li>`;

                            //Append Element
                            $(li).appendTo(this.$refs.responsebasemessage.children);

                        });
                        

                    break;

                }

            }

            //Remove Base Response Message
            this.removeResponseMessages();

            return;

        },
        checkValueByFocus(element){

            //Get Value
            let input = element.currentTarget;

            //Check Value
            if(input.value !== ''){

                this.disabled = false;

                return this.disabled;

            }

        },
        errorConditional(message, clientid, token, formaction){

            //Desactive Loading
            document.querySelector('.loadingbase').classList.remove('d-flex');

            //Enabled Submit
            document.querySelector('.btnsubmit').removeAttribute('disabled');

            //Check values
            if(clientid === '' && token === '' || 
            !Number.isInteger(parseInt(clientid)) ||
            token === ''
            ){

                //Send Message
                alert(message);

                return true;

            }

            return false;

        },
        sendData(formaction){

            //Disabled Submit
            document.querySelector('.btnsubmit').setAttribute('disabled', true);

            //Active Loading
            document.querySelector('.loadingbase').classList.add('d-flex');

            //Check by Error Conditional
            let errorexist = this.errorConditional('Por favor apenas enviar dados válidos', this.instagram_clientid, this.instagram_token, formaction);

            //When Error Exists
            if(errorexist){

                return;

            }

            //Set Route
            let method;
            let urlmethod;
            let dataForm = {}; 

            switch(formaction)
            {

                case 'insert':

                    method = 'POST';
                    urlmethod = this.feedstore;

                    //Set Data Form
                    dataForm.feedtype = document.querySelector('.feedsettings').getAttribute('data-feedtype');
                    dataForm.data = {
                        feedclientid: this.instagram_clientid,
                        feedtoken: this.instagram_token
                    };
                    
                break;

                case 'update':

                    method = 'PUT';
                    urlmethod = this.feedupdate;

                    //Set Data Form
                    dataForm.feedid = document.querySelector('.feedsettings').hasAttribute('data-feedid') 
                    ? document.querySelector('.feedsettings').getAttribute('data-feedid') : null;
                    dataForm.data = {
                        feedclientid: this.instagram_clientid,
                        feedtoken: this.instagram_token
                    };

                break;

                case 'delete':

                    method = 'DELETE';
                    urlmethod = '';

                break;

                case 'active':

                    method = 'PUT';
                    urlmethod = '';

                break;

            }

            //Check Data Form
            if(Object.keys(dataForm).length > 0){

                //Send Data
                let response = fetchData.structureTosendData(urlmethod, dataForm, this.csrftolken, method);

                //Check Response
                response.then((value) => {

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Generate a Response
                    return this.dataStructureResponse(value);

                }).catch((error) => {

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Enabled Submit
                    document.querySelector('.btnsubmit').removeAttribute('disabled');

                    throw new Error(error);

                });

            }else{

                //Send Message
                alert('Por favor apenas enviar dados válidos');

                //Desactive Loading
                document.querySelector('.loadingbase').classList.remove('d-flex');

                //Enabled Submit
                this.disabled = false;

                return;

            }

        },

    },
    components:{

        computedAllData(){

            return this.alldata;

        },
        computedFormAction(){

            return this.formaction;

        },
        computedInstagramClientId(){

            return this.instagram_clientid;

        },
        computedInstagramToken(){

            return this.instagram_token;

        },
        computedDisabledBtn(){

            return this.disabled;

        }

    },
    watch:{

        computedAllData(){},
        computedFormAction(){},
        computedInstagramClientId(){},
        computedInstagramToken(){},
        computedDisabledBtn(){}

    },
    components:{

        listMessage: ListMessage,
        loading: Loading,

    }

}

</script>